// pages/auth-card.ts — shared chrome for the placeholder auth pages
// (verify-email / verified / forgot-password / reset-password).
//
// A small centered card on paper background. Used by every auth route
// EXCEPT login / signup, which own their own full-screen split layout.

import type { Page, PageContext } from '../router';
import { html, arrowR } from '../util';

export interface AuthCardConfig {
  eyebrow: string;
  title: string;
  body: string;
  ctaLabel: string;
  ctaRoute: string;
  ctaArrow?: boolean;
}

export function makeAuthCardPage(cfg: AuthCardConfig): Page {
  return {
    render(_ctx: PageContext): string {
      return html`
        <div class="bff-auth-card-wrap">
          <div class="card bff-auth-card">
            <div class="eyebrow" style="display: inline-block;">${cfg.eyebrow}</div>
            <h1 class="t-h2" style="margin: 16px 0 0;">${cfg.title}</h1>
            <p class="t-body" style="margin-top: 24px;">${cfg.body}</p>
            <div style="margin-top: 32px;">
              <a class="btn btn-primary" data-nav="${cfg.ctaRoute}">
                ${cfg.ctaLabel}${{ __raw: cfg.ctaArrow ? html` ${{ __raw: arrowR() }}` : '' }}
              </a>
            </div>
          </div>
        </div>
      `;
    },
  };
}
